import { companyContactId, individualContactId } from "@inrev/common";
import * as z from "zod";
import { defineTool } from "../tool-definition";

/** Null flags mean the link carries no contract config, which the platform reads as not included. */
const linkFlags = {
	includeInUnderwriting: z.boolean().nullable(),
	includeInIndemnity: z.boolean().nullable(),
	hasCreditPull: z.boolean(),
};

export const getParties = defineTool({
	name: "get_parties",
	description:
		"Every company and individual linked to the account. `isPrimaryCompany` marks the one company that anchors the account; the principal on a given bond can be a different company. `includeInUnderwriting` and `includeInIndemnity` come from the party's link to this account: a party excluded from indemnity is a waived indemnitor. `hasCreditPull` says whether any credit pull exists; read results with `get_credit`. Individuals are never principals.",
	label: "Parties",
	contexts: ["account", "bond_request", "bond"],
	implementation: "api",
	audience: "model",
	input: z.strictObject({}),
	data: z.strictObject({
		companies: z.array(
			z.strictObject({
				partyId: companyContactId,
				name: z.string(),
				isPrimaryCompany: z.boolean(),
				email: z.string().nullable(),
				...linkFlags,
			}),
		),
		individuals: z.array(
			z.strictObject({
				partyId: individualContactId,
				name: z.string(),
				spousePartyId: individualContactId.nullable(),
				ownsAHome: z.boolean().nullable(),
				email: z.string().nullable(),
				...linkFlags,
			}),
		),
	}),
});
